/** #################################### Generated content ####################################
 * This block has been generated with deppy create-index (for more information https://github.com/webedx-spark/deppy)
 **/

/**
 * @description generated: list of files importing the export below
 * @link file://./../../bundles/certificate-enroll/components/PhoenixEnrollButton.tsx
 * @link file://./../../bundles/verificationDisplay/promises/verificationDisplay.ts
 */
export {
  /**
   * @deprecated The `productOwnershipPromise` function is outdated and only supports the case of `VERIFIED_CERTIFICATE`.
   * Please use `static/bundles/entitlements-common/hooks/useProductOwnerships.ts` for a more comprehensive solution.
   */
  default as productOwnershipPromise,
} from './promises/productOwnership';
/**
 * @description generated: list of files importing the export below
 * @link file://./../../bundles/in-course-stores/stores/S12nStore.ts
 * @link file://./../../bundles/s12n-common/service/promises/s12nOwnershipPromiseFactory.ts
 */
export {
  /**
   * @deprecated The `CourseOwnerships` Backbone model is outdated, please use type from `static/bundles/entitlements-common/hooks/useProductOwnerships.ts`.
   */
  default as CourseOwnerships,
} from './models/courseOwnerships';
/**
 * @description generated: list of files importing the export below
 * @link file://./../../bundles/in-course-stores/stores/VerificationStore.ts
 * @link file://./../../bundles/s12n-common/service/promises/s12nOwnershipPromiseFactory.ts
 */
export {
  /**
   * @deprecated The `productOwnership` Backbone model is outdated, please use type from `static/bundles/entitlements-common/hooks/useProductOwnerships.ts`.
   */
  default as ProductOwnership,
} from './models/productOwnership';

/**
 *  #################################### Generated content ####################################
 **/
